import EcoSection from 'eco-design/base/eco-section';

import getLocal from '@/app/utils/getLocal';
import { useGlobal } from '@/utils/useGlobal';
import EcoImg from 'eco-design/base/eco-img';
import { FC } from 'react';
import MinTitle from '../MinTitle';
import styled from './index.module.scss';
import stylesIt from './it.module.scss';

interface PlugProps {
    pageType: string;
}
const euPages = ['normal', 'ultra', 'ac'];

const Plug: FC<PlugProps> = ({ pageType = 'normal' }) => {
    const { locale } = getLocal();
    const { useLang, useState, gtm, isMobile } = useGlobal();

    const { t } = useLang('theProduct.Plug');
    const pageTypeObj: any = {
        normal: {
            title: t('title'),
            subTitle: t('subTitle'),
            items: [
                {
                    desc: t('item1_desc'),
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1745314638975/Frame%201612690062.png',
                    title: t('item1_title'),
                },
                {
                    desc: t('item2_desc'),
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1745314661702/Frame%201612690061.png',
                    title: t('item2_title'),
                },
            ],
        },
        ultra: {
            title: locale === 'uk' ? t('ultra_title') : t('title'),
            subTitle: ['uk', 'fr'].includes(locale) ? t('ultra_subTitle') : t('subTitle'),
            items: [
                {
                    desc: locale === 'uk' ? t('ultra_item1_desc') : t('item1_desc'),
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1745314638975/Frame%201612690062.png',
                    title: locale === 'uk' ? t('ultra_item1_title') : t('item1_title'),
                },
                {
                    desc: locale === 'uk' ? t('ultra_item2_desc') : t('item2_desc'),
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1745314661702/Frame%201612690061.png',
                    title: locale === 'uk' ? t('ultra_item2_title') : t('item2_title'),
                },
            ],
        },
        ac: {
            title: t('title'),
            subTitle: t('subTitle'),
            items: [
                {
                    desc: t('item1_desc'),
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1745314638975/Frame%201612690062.png',
                    title: t('item1_title'),
                },
                {
                    desc: t('item2_desc'),
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1745314661702/Frame%201612690061.png',
                    title: t('item2_title'),
                },
            ],
        },
        na: {
            title: t('title'),
            subTitle: t('subTitle'),
            items: [
                {
                    desc: t('item1_desc'),
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1744957264166/Frame%201612690062.jpg',
                    title: t('item1_title'),
                },
                {
                    desc: t('item2_desc'),
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1744957263982/Frame%201612690061.jpg',
                    title: t('item2_title'),
                },
            ],
        },
    };
    const objectA = pageTypeObj[pageType] || pageTypeObj['normal'];
    const itemsA = objectA.items || [];
    const itemsIt = itemsA[1] || {};
    return (
        <section className={`${styled.Plug} ${styled[`Plug_${pageType}`]}`} id="Plug">
            <div className={`plug-container ${pageType}`}>
                {euPages.includes(pageType) && <MinTitle title={t('min_title')} align="center" />}
                <EcoSection className="plug-box-title product-section" subTitle={objectA.subTitle} title={objectA.title} subTitleColor="#696C71" />
                <div className={stylesIt.PlugIt}>
                    <div className="PlugIt-l">
                        <EcoImg pc={itemsIt.pc} />
                    </div>
                    <div className="PlugIt-r">
                        <div className="PlugIt-title">{itemsIt.title}</div>
                        <div className="PlugIt-desc">{t('it_item2_desc')}</div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Plug;
